export enum WorldWideEnum {
  Territories = 16,
  EgyptTerriotry = 1,
  AllOperators = 45,
  Renewal = 2,
  BulkSMSTemplateid = 9,
  ContentDistribution = 1,
  SMSProduct = 2,
  Bulkagreement_Type_FK = 8,
  NormalAnnex = 1,
  TerminateContract = 3,
  NovationAnnex = 4
}

export enum DocumentTypeEnum {
      All = 0,
    Contract = 1,
    PersonalID = 2,
    CommercialRegister = 3,
    TaxID = 4,
    BusinessCase = 5,
    AuthorizationLetter = 6,
    ConcessionLetter = 7,
    Annex = 8,
    OtherFiles = 9,
    Certifications = 1008
}

export enum ProcessDocTypeEnum{
  Contract =1,
  Annex
}